export default {"src":"/assets/turbo/a35329d6/ackermannch/_next/static/media/favicon.c39a2a5c.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};